import React from "react";
import HeroSloganArea from "./main/components/HeroSloganArea";
import AiPromoBanner from "./main/components/AiPromoBanner";
import HeroQuoteSection from "./main/components/HeroQuoteSection";
import { InfoTabSection } from "@components";
import SeriousAccidentInfographic from "./main/components/SeriousAccidentInfographic";
import FeatureCarousel from "./main/components/FeatureCarousel";

const hero = {
  sloganKo: "AI와 함께하는 스마트 안전관리",
  sloganEn: "AI-POWERED WORKPLACE SAFETY PLATFORM",
  subtitle: "중대재해처벌법 대응부터 현장 안전관리까지,\nAI 기술로 더 쉽고 정확하게. 우리 회사의 안전을 한 곳에서 관리하세요.",
};

const workerPanel = {
  quoteKo: "작은 실천이 큰 사고를 막습니다",
  quoteEn: "SMALL ACTIONS PREVENT BIG ACCIDENTS",
};

const Main = () => {
  return (
    <div className="contents-wrap !mt-0 bg-slate-50 !px-0 pt-0 pb-6">
      {/* Hero + Quote — 여백 없이 붙여서 하나의 블록처럼 */}
      <div className="flex flex-col [&>*]:!m-0 [&>section]:!m-0">
        <HeroSloganArea hero={hero} />
        <HeroQuoteSection quoteKo={workerPanel.quoteKo} quoteEn={workerPanel.quoteEn} />
      </div>

      {/* 이하 섹션은 가독성을 위해 내부 패딩만 적용 */}
      {/* 2) 중대재해 인포그래픽 (요청 이미지 스타일) */}
      <SeriousAccidentInfographic />

      {/* 3) AI 알리미 홍보 띠 배너 — 꽉 차는 풀너비 */}
      <AiPromoBanner />

      <div className="px-3 sm:px-4 md:px-6 lg:px-8">

        {/* 4) 주요 기능 캐러셀 */}
        <FeatureCarousel />

        {/* 5) 법령요지·회사지침·조직도 카드 */}
        <div className="mt-6">
          <InfoTabSection />
        </div>
      </div>
    </div>
  );
};

export { Main };
